import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { InputModelWithSource } from '../../models';
import { InputWithSource } from '../../componentTypes';
import { GenericSelect } from '../../components';

const ReasonForClauseInput: InputWithSource = ({ input }) => {
    const options = input.sourceProvider.options;
    const optionCount = options.length;
    const optionValue = options[0]?.value;

    React.useEffect(() => {
        if (input.required && !input.isReadOnly && !input.hasValue && optionCount === 1) {
            input.setValue(optionValue);
        }
    }, [input, input.hasValue, input.isReadOnly, input.required, optionCount, optionValue]);

    return <GenericSelect label={input.name} input={input} />;
};

ReasonForClauseInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(ReasonForClauseInput);
